mutation UpdateCurrentUser($input: UpdateCurrentUserInput!) {
  updateCurrentUser(input: $input) {
    id
    firstName
    lastName
    middleName
    email
    phone
    country
    language
    timeZone
    agreeToMarketingNewsletters
    currentOrganizationId
    currentOrganization {
      id
      title
      currency
    }
    currentOrganizationRoles
    abilityRules
    avatar {
      id
      url(format: SMALL)
    }
    isPartner
  }
}

